import React from "react";

import {
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Heading,
} from "@chakra-ui/react";

const Persons = ({ showAll, persons, filteredName, deletePerson }) => {
  return (
    <>
      <Heading as="h2" mb="30px" mt="10px">
        Details
      </Heading>
      <TableContainer bg="white" border="1px solid" borderColor="gray.400">
        <Table size={{ base: "sm", lg: "md" }}>
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Number</Th>
              <Th>Remove</Th>
            </Tr>
          </Thead>
          <Tbody>
            {showAll && persons !== null
              ? persons.map((person) => (
                  <Tr key={person.id}>
                    <Td>{person.name}</Td>
                    <Td>{person.number} </Td>
                    <Td pl="30px">
                      <Button
                        value={person.name}
                        onClick={deletePerson}
                        colorScheme="red"
                      >
                        Delete
                      </Button>
                    </Td>
                  </Tr>
                ))
              : persons
                  .filter((person) =>
                    person.name
                      .toLowerCase()
                      .includes(filteredName.toLowerCase())
                  )
                  .map((person) => (
                    <Tr key={person.id}>
                      <Td>{person.name}</Td>
                      <Td> {person.number} </Td>
                      <Td>
                        {
                          <Button
                            colorScheme="red"
                            value={person.name}
                            onClick={deletePerson}
                          >
                            Delete
                          </Button>
                        }
                      </Td>
                    </Tr>
                  ))}
          </Tbody>
        </Table>
      </TableContainer>
    </>
  );
};

export default Persons;
